<template>
  <div>
    <BaseTitle
      :title="$t(type === 'template' ? `content.template_e_rapor` : type === 'generator' ? 'content.template_integ' : 'content.template_generate')"
      :yearPeriode="titleData"
    />

    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">
            List
            {{ $t(type === 'template' ? `content.template_e_rapor` : type === 'generator' ? 'content.template_integ' : 'content.template_generate') }}
          </div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                @click="addPages()"
                v-if="(permissionButton('ROLE_ERAPOR_VIEW') && type === 'template') || (permissionButton('ROLE_ERAPOR_VIEW') && type === 'generator')"
                >{{ $t('add') }}</v-btn
              >
            </div>
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @input="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div class="border-item" v-for="(item, index) in datas" :key="index">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="ic_erapor" width="35" height="35" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col md="10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.name ? `${item.name}` : `${item.integrationName}` }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('table.last_update') }} :
                      <strong>{{ item.createdAt ? `${item.createdAt}` : `${item.date}` }}</strong>
                    </span>
                    |
                    <span class="mr-3">
                      {{ $t('content.by') }} :
                      <strong>{{ item.createdBy ? `${item.createdBy}` : `${item.by}` }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item v-if="permissionButton('ROLE_ERAPOR_VIEW')">
                        <v-list-item-title
                          class="text-dropdown"
                          @click="goView(item.eraporTemplateId ? item.eraporTemplateId : item.eraporIntegrationTemplateId)"
                          >{{ $t('view') }}</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (permissionButton('ROLE_ERAPOR_UPDATE') && type === 'generator' && item.editable === true) ||
                            (permissionButton('ROLE_ERAPOR_UPDATE') && type === 'template')
                        "
                      >
                        <v-list-item-title
                          class="text-dropdown"
                          @click="goEdit(item.eraporTemplateId ? item.eraporTemplateId : item.eraporIntegrationTemplateId)"
                          >{{ $t('edit') }}</v-list-item-title
                        >
                      </v-list-item>
                      <v-list-item
                        v-if="
                          (permissionButton('ROLE_ERAPOR_DELETE') && type === 'generator' && item.editable === true) ||
                            (permissionButton('ROLE_ERAPOR_DELETE') && type === 'template' && item.deleteable === true)
                        "
                      >
                        <v-list-item-title class="text-dropdown-delete" @click="goDelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
            <!-- Dialog Delete -->
            <v-dialog v-model="dialogDelete" persistent max-width="290">
              <v-card>
                <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
                <v-card-text>{{ $t('delete_message') }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
                  <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
        <NoData v-if="!datas.length" />
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';

export default {
  name: 'TemplateGeneratorIndex',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      permission: 'Auth/permission',
      user: 'Auth/user'
    })
  },
  data: () => ({
    loadingButton: false,
    dialogDelete: false,
    loadingLoad: false,
    dataClass: '',
    datas: '',
    search: '',
    currentItem: '',
    titleData: ''
  }),
  methods: {
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getData() {
      let methods;
      if (this.type === 'template') {
        methods = 'fetchListTemplate';
      }
      //  else if (this.type === 'integ') {
      //   methods = 'fetchListIntegration';
      // }
      else if (this.type === 'generator') {
        methods = 'fetchListGenerateErapor';
      }
      this.loadingLoad = true;
      this.$store
        .dispatch(`TemplateErapor/${methods}`, {
          search: this.search
        })
        .then(res => {
          this.datas = res;
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    },
    addPages() {
      if (this.type === 'template') {
        if (this.user.roleId !== 2) {
          this.$router.push({ name: 'eRaporTemplateCreate' });
        } else {
          this.$router.push({ name: 'eRaporTemplateSchoolAdminCreate' });
        }
      } else if (this.type === 'generator') {
        this.$router.push({ name: 'eRaporIntegCreate' });
      }
    },
    goView(id) {
      if (this.type === 'template') {
        if (this.user.roleId !== 2) {
          this.$router.push({ name: 'eRaporTemplateView', params: { id } });
        } else {
          this.$router.push({ name: 'eRaporTemplateSchoolAdminView', params: { idTemplate: id } });
        }
      } else if (this.type === 'integ') {
        this.$router.push({ name: 'eRaporIntegView', params: { id } });
      } else if (this.type === 'generator') {
        this.$router.push({ name: 'eRaporGeneratorView', params: { id } });
      }
    },
    goEdit(id) {
      console.info(id);
      if (this.type === 'template') {
        if (this.user.roleId !== 2) {
          this.$router.push({ name: 'eRaporTemplateEdit', params: { id } });
        } else {
          this.$router.push({ name: 'eRaporTemplateSchoolAdminEdit', params: { idTemplate: id } });
        }
      } else if (this.type === 'generator') {
        this.$router.push({ name: 'eRaporIntegEdit', params: { id } });
      }
    },
    goDelete(item) {
      this.dialogDelete = true;
      if (this.type === 'template') {
        this.currentItem = item.eraporTemplateId;
      } else {
        this.currentItem = item.eraporIntegrationTemplateId;
      }
    },
    deleteDetail() {
      if (!this.currentItem) return false;
      let methods;
      if (this.type === 'template') {
        methods = 'destroyTemplate';
      } else {
        methods = 'destroyIntreg';
      }

      this.loadingButton = true;
      this.$store
        .dispatch(`TemplateErapor/${methods}`, this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.section-footer {
  border-radius: 4px 4px 0 0;
  background: #e7f5ff;
}
.header-circle {
  background-color: #00bf63;
  border: 1px solid #ffffff;
  border-radius: 8px;
  width: 110px;
  height: 23px;
}
.header-circle-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  margin-left: 10px;
}
.border-item {
  border-bottom: 1px solid #dedede;
}
.assignment-item {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 1px solid #dedede;
  // &:last-child {
  //   border-bottom: 0;
  //   // border-bottom: 1px solid #dedede;
  // }

  &-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    text-align: center;
    line-height: 24px;
    margin-right: 12px;

    svg {
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}

.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00bf63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}

.user {
  &-photo {
    width: 48px;
    height: 48px;
    overflow: hidden;
    border-radius: 100px;
    margin-right: 10px;
  }
}

.assigment-icon {
  width: 30px;
  height: 30px;
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
